import YatungButton from '@Src/_basic/components/YatungButton';
import YatungPage from '@Src/_basic/components/YatungPage';
import CancelIcon from '@Src/_basic/icons/Cancel';
import { CustomStandardData } from '@Src/_basic/object/CustomStandardType';
import { StandardV2Api } from '@Src/_basic/protocol/standardV2/custom/CustomStandardV2Api';
import { Stack, Typography } from '@mui/material';
import qs from 'qs';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import ViewCustomStandardCard from '../components/ViewCustomStandardCard';

const background = '/media/images/applicationsMange/customStandardBG.png';

export default function ViewCustomStandardScreen() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t: i18T } = useTranslation();
  const [typeId, setTypeId] = useState<number>(0);
  const [customStandard, setCustomStandard] = useState<CustomStandardData | undefined>(undefined);

  const queryObject = useMemo(() => qs.parse(location.search, { ignoreQueryPrefix: true }), [location.search]);

  const getCustomStandard = (id: number) => {
    StandardV2Api.getCustomStandardById(id, onGetCustomStandardSuccess);
  };

  const onGetCustomStandardSuccess = (data: CustomStandardData) => {
    setCustomStandard(data);
  };

  const handleCancelButtonClick = () => {
    navigate(`/qualityManagement/customStandards/list?typeId=${queryObject.typeId}`, { replace: true });
  };

  useEffect(() => {
    if (location.search) {
      const queryObject = qs.parse(location.search, { ignoreQueryPrefix: true });
      if (queryObject.customStandardId) {
        getCustomStandard(parseInt(queryObject.customStandardId.toString()));
      }
      if (queryObject.typeId) {
        setTypeId(parseInt(queryObject.typeId.toString()));
      }
    }
  }, [location.search]);

  return (
    <YatungPage
      title={i18T('QUALITY_MANAGE.SIDE_MENU.STANDARDIZED_PENALTY_MANAGEMENT.CUSTOM_STANDARD')}
      backgroundImage={background}
      body={
        <>
          <Stack direction="row" spacing={2} justifyContent="space-between">
            <Stack direction="row" spacing={2} sx={{ py: 1 }} />
            <Stack direction="row" spacing={2} sx={{ py: 1 }}>
              <YatungButton text="返回" startIcon={<CancelIcon />} color="blue" onClick={handleCancelButtonClick} />
            </Stack>
          </Stack>
          {customStandard && (
            <Stack direction="row" spacing={2} justifyContent="space-between">
              <Stack direction="row" spacing={2} sx={{ py: 1 }} />
              <Stack direction="row" spacing={2} sx={{ py: 1 }}>
                <Typography
                  sx={{
                    fontFamily: 'Inter,sans-serif',
                    fontStyle: 'normal',
                    fontWeight: '900',
                    lineHeight: '19px',
                    letterSpacing: '0.255em',
                  }}
                >
                  ID: {customStandard.code}
                </Typography>
              </Stack>
            </Stack>
          )}
          <ViewCustomStandardCard customStandard={customStandard} typeId={typeId} />
        </>
      }
    />
  );
}
